import "./App.scss";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import Header from "./components/header.js";
import { BrowserRouter } from "react-router-dom";
import Elem from "./pages/routes.js";
import Footer from "./components/Footer.js";

function App() {
  return (
    <BrowserRouter>
      <div className="App d-flex flex-column min-vh-100 bg-light">
        <div className="header">
             <Header />
        </div>
        <div className="main flex-grow-1">
          <Elem />
        </div>
        <div className="footer">
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
